import classNames from "classnames";
import tag from "html5-tag";
import {
  editableLayers,
  renderToolsItem,
  findActive,
  isLayerActive,
  getDsGeomType
} from "../helpers/";

export default (node, treeOptions, store) => {
  const {
    id,
    source_id,
    name,
    children,
    state,
    geom_type,
    datatype,
    cruds
  } = node;
  const droppable = treeOptions.droppable;
  const { depth, open, path, total, selected = false, filtered } = state;
  const childrenLength = children.length;
  const more = node.hasChildren();
  let isActive;
  let checked;
  let isLoading;

  if (store.editMode) {
    if (store.checkedNodes.indexOf(node) !== -1) checked = true;
  }

  switch (store.module) {
    case "mapTree":
      isActive = store.isActive(id) || findActive(store, node, store.module);
      isLoading = store.loadingLayersId.indexOf(id);
      break;
    default:
      isActive =
        isLayerActive(store.activeLayersId, id) ||
        findActive(store, node, store.module);
      break;
  }

  if (filtered === false) return;

  const toggler = tag(
    "span",
    {
      "data-id": id,
      "node-type": "toggler",
      class: classNames(`${treeOptions.togglerClass} el-icon-caret-right`, {
        open: more && open,
        hide: !more
      })
    },
    ""
  );

  let icon;

  switch (node.datatype) {
    case "model":
      icon = `<i
        class="ritm-tree__item-icon model"
        data-id=${id}
        data-source-id=${source_id}
        data-type=${datatype}
        node-name=${name}
      ></i>`;
      break;
    case "tile_layer":
      icon =
        store.module === "mapTree" && isLoading !== -1
          ? `<i
              class="ritm-tree__item-icon el-icon-loading"
              data-id=${id}
              data-source-id=${source_id}
              data-type=${datatype}
              node-name=${name}
            ></i>`
          : `<i
              class="ritm-tree__item-icon tilelayer"
              data-id=${id}
              data-source-id=${source_id}
              data-type=${datatype}
              node-name=${name}
            ></i>`;
      break;
    default:
      if (store.module === "mapTree" && isLoading !== -1) {
        icon = `<i
          class="ritm-tree__item-icon el-icon-loading"
          data-id=${id}
          data-source-id=${source_id}
          data-type=${datatype}
          node-name=${name}
        ></i>`;
      } else {
        icon =
          !source_id &&
          store.module !== "constructorDsTree" &&
          store.module !== "dsManagerTree"
            ? `<i
              class="ritm-tree__item-icon folder"
              data-id=${id}
              data-source-id=${source_id}
              data-type=${datatype}
              node-name=${name}
            ></i>`
            : `<i
              class="ritm-tree__item-icon ${getDsGeomType(node.geom_type)}"
              data-id=${id}
              data-source-id=${source_id}
              data-type=${datatype}
              node-name=${name}
            ></i>`;
      }

      break;
  }

  const title = tag(
    "span",
    {
      class: "infinite-tree-title",
      "data-id": id,
      "data-source-id": source_id,
      "data-type": datatype,
      "node-type": "title",
      "node-name": name
    },
    name
  );
  const renameInput = tag(
    "input",
    {
      class: "ritm-input tree-node__rename",
      "data-id": id,
      "data-source-id": source_id,
      "data-type": datatype,
      "node-type": "title",
      "node-name": name
    },
    ""
  );
  let inner = store.renameModeNodeId === id ? renameInput : title;
  let dsToolsItems = "";
  let dsToolsBlock = "";
  let dsToolsBlockWrap = "";
  let module = {
    map: {
      model: ["export"],
      layer: ["flytolayer"]
    },
    dsTree: cruds && cruds[5] ? ["export"] : []
  };
  if (
    editableLayers.indexOf(datatype ? datatype : geom_type) > -1 &&
    store.mapHasEditor
  )
    module.map.layer.unshift("editor");
  // if (store.hasBook) module.map.layer.unshift("book"); TODO: think about it
  if (
    store.mapHasStyles ||
    store.mapHasFilters ||
    store.mapHasHeatmaps ||
    store.mapHasDiagrams
  )
    module.map.layer.unshift("settings");

  if (store.showTools) {
    switch (store.module) {
      case "mapTree":
        if (node.datatype === "model") {
          module.map.model.forEach(
            e => (dsToolsItems += renderToolsItem(e, node))
          );
        } else if (!children.length && datatype !== "last_tracks") {
          module.map.layer.forEach(
            e => (dsToolsItems += renderToolsItem(e, node))
          );
        }
        break;
      default:
        if (datatype === "model" || !children || !children.length) {
          module.dsTree.forEach(
            e => (dsToolsItems += renderToolsItem(e, node))
          );
        }
        break;
    }
  }

  if (store.module === "constructorTree" && store.editMode)
    dsToolsItems += renderToolsItem("rename", node);

  let treeNode = tag(
    "div",
    {
      "data-id": id,
      class: "infinite-tree-node",
      style: `padding-left: ${depth * 12}px`,
      "data-source-id": source_id,
      "data-type": datatype,
      "node-name": name
    },
    toggler + icon + inner
  );

  if (dsToolsItems) {
    dsToolsBlockWrap = tag(
      "div",
      { class: "ritm-tree__tools-wrapper", "data-id": id },
      dsToolsItems
    );
    dsToolsBlock = tag("div", { class: "ritm-tree__tools" }, dsToolsBlockWrap);
    treeNode += dsToolsBlock;
  }

  let isDragHovered = { nodeId: "", pseudo: "" };

  if (store.dragHoveredItem.nodeId === id) {
    isDragHovered.nodeId = true;
  }
  if (store.dragHoveredItem.pseudo) {
    isDragHovered.pseudo = store.dragHoveredItem.pseudo;
  }

  return tag(
    "div",
    {
      draggable: "true",
      "data-id": id,
      "data-expanded": more && open,
      "data-depth": depth,
      "data-path": path,
      "data-selected": selected,
      "data-children": childrenLength,
      "data-total": total,
      class: classNames(`infinite-tree-item ${store.dragHoveredItem.pseudo}`, {
        "infinite-tree-selected": checked && store.editMode,
        dragHovered: isDragHovered.nodeId,
        active: isActive,
        model: node.datatype === "model"
      }),
      droppable: droppable
    },
    treeNode
  );
};
